import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../hooks/index';
import { logout } from '../store/slices/authSlice';
import Dashboard from '../components/Dashboard';

const DashboardPage: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { token, role } = useAppSelector((state) => state.auth);

    const handleLogout = () => {
        dispatch(logout());
        navigate('/login');
    };

    const setToken = (newToken: string) => {
        // This is a no-op since we're using Redux
    };

    const setRole = (newRole: string) => {
        // This is a no-op since we're using Redux
    };

    return (
        <Dashboard
            token={token}
            role={role}
            setToken={setToken}
            setRole={setRole}
            onLogout={handleLogout}
        />
    );
};

export default DashboardPage; 